<template>
    <div>
        <div class="btn btn-sm btn-clean btn-icon btn-icon-sm">
            <i @click="removeAccount" class="fa fa-trash"></i>
        </div>
        <div class="btn btn-sm btn-clean btn-icon btn-icon-sm" data-toggle="modal" :data-target="'#edit_account_modal'+row.id">
            <i class="fa fa-eye"></i>
        </div>
        <div :id="'edit_account_modal'+row.id" class="modal fade rtl" role="dialog">
            <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content">
                    <div id="data_sheet" class="modal-body mb-4">
                        <div class="modal-header">
                            <h4 class="modal-title">
                                {{ $t('deposit.account_details') }} {{ ' ' + row.id }}
                            </h4>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="m-4">
                            <form @submit.prevent="editAccount" method="post" id="edit_account">
                                <kt-form-section>
                                    <kt-form-row>
                                        <kt-col xs="12" sm="12" md="12">
                                            <kt-form-group>
                                                <kt-form-label for="title">
                                                    {{ $t('label.title') }}
                                                </kt-form-label>
                                                <kt-form-control
                                                        ref="title"
                                                        dir="rtl"
                                                        name="title"
                                                        id="title"
                                                        v-model="row.title"
                                                />
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col xs="12" sm="12" md="12">
                                            <kt-form-group>
                                                <kt-form-label for="sheba">
                                                    {{ $t('label.sheba_number') }}
                                                </kt-form-label>
                                                <kt-form-control
                                                        style="direction: ltr"
                                                        id="sheba"
                                                        name="sheba"
                                                        v-model="row.sheba"
                                                        :class="'form-control transfers_destination_number'+row.id"
                                                ></kt-form-control>
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col xs="12" sm="12" md="12">
                                            <kt-form-group>
                                                <kt-form-label for="account_number">
                                                    {{ $t('label.account_number') }}
                                                </kt-form-label>
                                                <kt-form-control
                                                        ref="account_number"
                                                        dir="ltr"
                                                        name="account_number"
                                                        id="account_number"
                                                        v-model="row.account_number"
                                                />
                                            </kt-form-group>
                                        </kt-col>
                                    </kt-form-row>
                                </kt-form-section>
                                <kt-form-section>
                                    <kt-row>
                                        <kt-col xs="12" sm="6" md="6">
                                            <button
                                                    class="btn btn-success btn-wide float-left"
                                                    size="md"
                                                    type="submit"
                                                    id="edit_account_btn"
                                            >
                                                {{ $t('btn.edit') }}
                                            </button>
                                        </kt-col>
                                    </kt-row>
                                </kt-form-section>
                            </form>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>
</template>

<script>
import Vue from 'vue'
import $ from "jquery";
import {KTApp} from '@/plugins/core/app'
import {i18n} from "@/plugins/i18n";
import toastr from "toastr";
import Inputmask from "inputmask";
import {depositPfService, depositStarshopService} from "@/common/api.service";

export default Vue.extend({
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    },
    data() {
        return {
            depositPfService,
            depositStarshopService
        }
    },
    methods: {
        removeAccount: function () {
            var result = confirm(i18n.t('deposit.message.remove_account'));
            if (!result) return;

            this.apiService.removeAccount(this.row.id).then(response => {
                this.datatable.reload()
                return this.toastr.success(response.data.message)
            }).catch(({response}) => {
                return this.toastr.error(response.data.message)
            });
        },
        editAccount: function () {
            let btn = $('#edit_account_btn')
            let form = $('#edit_account')

            form.validate({
                rules: {
                    title: {
                        required: true,
                    },
                    sheba: {
                        required: true,
                    },
                    account_number: {
                        required: true
                    },
                }
            });

            if (!form.valid()) {
                return
            }

            let sheba = this.row.sheba
            sheba = sheba.split('-').join('')
            sheba = sheba.split(' ').join('')
            sheba = sheba.split('_').join('')

            if (sheba.length != 26) return this.toastr.error(i18n.t('pos.message.invalid_sheba_format'))

            KTApp.progress(btn)
            let params = {
                title: this.row.title,
                bank_name: this.BankNameBySheba(sheba),
                sheba: sheba,
                account_number: this.row.account_number,
            }

            this.apiService.editAccount(this.row.id, params).then(response => {
                 $('#edit_account_modal'+ this.row.id).modal('hide')
                this.datatable.reload()
                this.toastr.success(response.data.message)
            }).catch(({response}) => {
                if (response.data) {
                    form.validate().showErrors(response.data.data)
                }
                KTApp.unprogress(btn)
                this.toastr.error(response.data.message)
            }).finally(() => {
                // KTUtil.scrollTop()
                KTApp.unprogress(btn)
            })
        },
        initShebaMask() {
            Inputmask("IR 9999-9999-9999-9999-9999-9999").mask(document.querySelectorAll('.transfers_destination_number' + this.row.id));
        }
    },
    watch: {
        row: {
            handler(newValue, oldValue) {
                this.initShebaMask()
            },
            deep: true

        },
    },
    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }
            return toastr
        },
        apiService() {
            return this.$route.params.gateway_source === 'pf' ? this.depositPfService : this.depositStarshopService;
        },
    }
})
</script>

<style>

</style>
